import React from 'react';
import {useI18n} from '../../../../../data/hooks/i18nHooks';
import StartNetworkingGroup from '../../StartNetworkingGroup/StartNetworkingGroup';
import StepAddBio from './StepAddBio';
import StepPhoto from './StepPhoto';
import StepProfileQuestions from './StepProfileQuestions';
import icon from './icon.png'

/**
 * Renders the "Get Found" group component.
 *
 * @param {Object} props - The props object
 * @param {number} props.eventId - The ID of the event.
 * @return {JSX.Element} The rendered "Get Found" group component.
 */
function GetFoundGroup(props) {
    const {eventId} = props,
        i18n = useI18n();

    return (
        <StartNetworkingGroup name={i18n['start.get_found']} description={i18n['start.get_found.intro']} icon={icon}>
            <StepPhoto />
            <StepProfileQuestions eventId={eventId} />
            <StepAddBio />
        </StartNetworkingGroup>
    );
}

export default GetFoundGroup;
